import AutoscalingIcon from '~/shared/assets/icons/auto-scale.svg';
import VectorIcon from '~/shared/assets/icons/vector.svg';
import KPICard from '~/shared/components/KPICard';
import Tag from '~/shared/components/Tag';
import {
  KPIHeader,
  KPIMetricGroup,
  KPIMetricSkeleton,
  KPISkeletonLoader,
  StorageChangeTag,
} from '~/shared/components/kpi';

export default function AutoscalingStorageSizeCard({
  originalSize,
  currentSize,
  changePercent,
  volumeCount,
  loading,
}: {
  originalSize: string;
  currentSize: string;
  changePercent: string | null;
  volumeCount: string;
  loading: boolean;
}) {
  return (
    <KPICard className="flex flex-col justify-between gap-[18px] min-w-[340px] h-full">
      <KPIHeader
        icon={AutoscalingIcon}
        title="Autoscaling Storage Size"
        subtitle="Volumes managed by Datafy"
      />
      <div className="flex items-end">
        {loading ? (
          <div className="flex items-end gap-2 w-full ">
            <KPIMetricSkeleton labelWidth={82} valueWidth={72} />
            <div className="w-2" />
            <KPIMetricSkeleton labelWidth={82} valueWidth={72} />
            <KPISkeletonLoader width={34} variant="valueSm" className="shrink-0 my-auto" />
            <div className="">
              <KPISkeletonLoader width={62} variant="tag" className="shrink-0 mt-auto" />
            </div>
          </div>
        ) : (
          <div className="flex justify-between gap-3 w-full">
            <div className="flex gap-2 w-full">
              <KPIMetricGroup label="Original Size" value={originalSize} />
              <VectorIcon className="size-5 mt-auto mb-1 text-gray-600" aria-hidden="true" />
              <KPIMetricGroup label="Current Size" value={currentSize} />
              {changePercent && (
                <StorageChangeTag changePercent={changePercent} className="mt-auto" />
              )}
              <Tag variant="kpi" size="kpi" text={volumeCount} className="mt-auto" showFullText />
            </div>
          </div>
        )}
      </div>
    </KPICard>
  );
}
